import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { merge, Subscription } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {
  private dialogSubscription!: Subscription;

  constructor(private readonly dialog: MatDialog) {}

  ngOnInit(): void {
    this.loadCopernic();
    this.loadLemonLearning();
    this.dialogSubscription = merge(this.dialog.afterOpened, this.dialog.afterAllClosed).subscribe(() => document.body.classList.toggle('dialog-open', this.dialog.openDialogs.length > 0));
  }

  ngOnDestroy(): void {
    this.dialogSubscription?.unsubscribe();
    document.body.classList.remove('dialog-open');
    const container = document.getElementById('assistant-copernic');
    if (container) {
      container.style.display = 'none';
    }
  }

  private loadCopernic(): void {
    const container = document.getElementById('assistant-copernic');
    if (container) {
      container.style.display = '';
      return;
    }

    const newContainer = document.createElement('div');
    newContainer.id = 'assistant-copernic';
    document.body.appendChild(newContainer);

    const script = document.createElement('script');
    script.src = 'https://chat.copernic.co/widget.js';
    script.setAttribute('api-key', 'YMsagZwz0z5yFK6F');
    document.body.appendChild(script);
  }

  private loadLemonLearning(): void {
    if (document.getElementById('lemonlearning-player-embed')) {
      return;
    }

    (window as any).LemonLearningReady = (player: any) => {
      player
        .set({
          projectKey: '1fb73335b3468d7882d397111a0340a9',
          user: player.userKey('18a82b228cc40e7d8a67742dcb893c18')
        })
        .start();
      player.hide();
    };

    const stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = 'https://static.lemonlearning.com/player/bundle.css';
    document.head.appendChild(stylesheet);

    const script = document.createElement('script');
    script.id = 'lemonlearning-player-embed';
    script.src = 'https://static.lemonlearning.com/player/bundle.js';
    script.async = true;
    document.head.appendChild(script);
  }
}
